// Styling constants + MapLibre paint helpers for the network plant.
// Kept deliberately close to the Vetro visual language:
//   feeder = red, distribution = orange, drops = lighter orange
//   junctions = dark slate circles with labels
//   drop terminals = cyan diamonds
// Planned-fiber palette — unified blue family.
// Reads as one network; type distinction is by line width, not hue.
// Old Vetro convention (red feeder + orange distribution) replaced
// on 2026-05-27 per request — single blue family is less visually noisy
// when the auto-design renders thousands of segments at low zoom.
export const SEGMENT_COLORS = {
    feeder_trunk: '#1d4ed8', // dark blue  — main spine
    backbone: '#1d4ed8',
    distribution: '#3b82f6', // medium blue — residential branches
    drop: '#60a5fa', // light blue  — per-home drops
    drop_tail: '#60a5fa',
    splice_tail: '#93c5fd', // very light  — pigtails
};
export const SEGMENT_WIDTH = {
    feeder_trunk: 5,
    backbone: 5,
    distribution: 3,
    drop: 2,
    drop_tail: 1.5,
    splice_tail: 2,
};
export const NODE_STYLE = {
    olt: { color: '#111827', strokeColor: '#f59e0b', radius: 10, shape: 'square' },
    headend: { color: '#111827', strokeColor: '#f59e0b', radius: 10, shape: 'square' },
    splice_closure: { color: '#1e293b', strokeColor: '#fff', radius: 7, shape: 'circle' },
    splitter: { color: '#8b5cf6', strokeColor: '#fff', radius: 8, shape: 'circle' },
    handhole: { color: '#1e293b', strokeColor: '#fff', radius: 6, shape: 'circle' },
    pedestal: { color: '#059669', strokeColor: '#fff', radius: 6, shape: 'square' },
    drop_terminal: { color: '#06b6d4', strokeColor: '#fff', radius: 5, shape: 'diamond' },
    ont: { color: '#06b6d4', strokeColor: '#fff', radius: 4, shape: 'circle' },
    mdu_bef: { color: '#dc2626', strokeColor: '#fff', radius: 6, shape: 'square' },
};
export const NODE_LABEL = {
    olt: 'OLT',
    headend: 'Head-end',
    splice_closure: 'Splice closure',
    splitter: 'Splitter',
    handhole: 'Handhole',
    pedestal: 'Pedestal',
    drop_terminal: 'Drop terminal',
    ont: 'ONT',
    mdu_bef: 'MDU entrance',
};
export const SEGMENT_LABEL = {
    feeder_trunk: 'Feeder',
    backbone: 'Backbone',
    distribution: 'Distribution',
    drop: 'Drop',
    drop_tail: 'Drop tail',
    splice_tail: 'Splice tail',
};
export function matchExpr(prop, map, fallback) {
    const arr = ['match', ['get', prop]];
    for (const [k, v] of Object.entries(map))
        arr.push(k, v);
    arr.push(fallback);
    return arr;
}
export function segmentPaint() {
    return {
        'line-color': matchExpr('type', SEGMENT_COLORS, '#2563eb'),
        'line-width': matchExpr('type', SEGMENT_WIDTH, 2),
        'line-opacity': 0.95,
    };
}
export function nodeCirclePaint() {
    // Render everything as a styled circle, differentiating by type.
    const colorMap = {};
    const strokeMap = {};
    const radiusMap = {};
    for (const [k, v] of Object.entries(NODE_STYLE)) {
        colorMap[k] = v.color;
        strokeMap[k] = v.strokeColor;
        radiusMap[k] = v.radius;
    }
    return {
        'circle-color': matchExpr('type', colorMap, '#6b7280'),
        'circle-stroke-color': matchExpr('type', strokeMap, '#fff'),
        'circle-stroke-width': 2,
        'circle-radius': matchExpr('type', radiusMap, 5),
    };
}
